import data from './reviews.json';
/**
 * The reviews, as they read on linkrobins.com/wall-of-love. Static: these are
 * real customer words, so they live in the source rather than being derived.
 *
 * Shared by /wall-of-love, which shows all of them under whatever members have
 * left since, and the home page, which shows the flagged three.
 *
 * Why only three are flagged: the wall is a record, the home page is a shop
 * window. Several of these praise the managed hosting, which is not sold any
 * more — true when it was written, and a dead end to put in front of somebody
 * arriving today. The flagged three speak to monitoring and to how the work
 * goes, both of which are still on the shelf.
 */
// The words themselves are in reviews.json, which the server also reads to
// put them in /wall-of-love's HTML for crawlers (Seo\PageContent).
export const REVIEWS = data;

/** The home page's band, in wall order. */
export function featured() {
  return REVIEWS.filter(r => r.featured);
}